import {
    inventoryClick,
    inventoryImpressions,
    inventorySave,
    inventoryCarouselPagination,
    ownerImpressions,
    ownerLogoClick,
    ownerWebsite,
    clickTypes,
} from 'reaxl-analytics-handlers';

export default {
    inventoryClick: (metadata, option) => {
        metadata.data.pixallData = {
            listingType: 'elot',
            eventSource: 'vehicle',
        };

        inventoryClick(metadata, option);
    },
    inventoryImpressions: (metadata, option) => {
        metadata.data.cmp = 'dl_v_lstg_';

        inventoryImpressions(metadata, option);
    },
    inventorySave: (metadata, option) => {
        metadata.data.par = `dl_v_lstg_${metadata.data.index + 1}`;
        metadata.data.pixallData = {
            eventType: 'save',
            listingType: 'elot',
        };
        inventorySave(metadata, option);
    },
    ownerImpressions: (metadata, option) => {
        metadata.data.pixallData = {
            ...metadata.data.pixallData,
            eventSource: 'dealership',
            listingType: 'elot',
            listingCode: metadata?.data.ownerIds?.[0],
        };
        ownerImpressions(metadata, option);
    },
    ownerLogoClick: (metadata, option) => {
        metadata.data = {
            ...metadata.data,
            par: 'dl_v_lstg',
            pixallData: {
                isCarousel: false,
                listingType: clickTypes.ELOT,
            },
            clickType: clickTypes.ELOT,
        };
        ownerLogoClick(metadata, option);
    },
    ownerWebsite: (metadata, option) => {
        metadata.data = {
            ...metadata.data,
            par: 'dl_v_lstg',
            pixallData: {
                isCarousel: true,
                listingType: clickTypes.ELOT,
            },
            clickType: clickTypes.ELOT,
        };
        ownerWebsite(metadata, option);
    },
    // we may not need this
    inventoryCarouselPagination: (metadata, option) => {
        inventoryCarouselPagination(metadata, option);
    }
}